import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Solutions from "@/components/site/Solutions";
import Capabilities from "@/components/site/Capabilities";
import Gallery from "@/components/site/Gallery";
import Process from "@/components/site/Process";
import WhyChoose from "@/components/site/WhyChoose";
import Trust from "@/components/site/Trust";
import Brands from "@/components/site/Brands";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[var(--nv-paper)] text-[var(--nv-navy)]">
      <Nav />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Solutions />
      <Capabilities />
      <Gallery />
      <Process />
      <WhyChoose />
      <Trust />
      <Brands />
      <Contact />
      <Footer />
    </main>
  );
}
